<h1 class="sr-only">{{ data.header }}</h1> <!-- main heading for screen readers -->
<h2 mat-dialog-title>{{ data.header }}</h2>
<mat-divider></mat-divider>
<mat-dialog-content role="main">
  <ng-container *ngIf="data?.param === 'terminate'">
    <form [formGroup]="terminateApplicationForm">
      <fieldset>
        <legend class="sr-only">Terminate Application Form</legend>
        <label for="terminationDate"> Termination Date:<sup class="star" style="color:#ea4848">*</sup></label><br>
        <mat-form-field>
          <mat-label>Select Termination Date</mat-label>
          <input id="terminationDate" matInput [matDatepicker]="picker" formControlName="terminationDate">
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker #picker></mat-datepicker>
        </mat-form-field>
        <br>
        <label for="terminationReason">Select Reason for Termination:<sup class="star" style="color:#ea4848">*</sup></label>
        <select id="terminationReason" class="form-select" formControlName="terminationReason">
          <option *ngFor="let reasonOption of data.content[0].reasonsDropdown" [value]="reasonOption">
            {{ reasonOption }}</option>
        </select>
        <div *ngIf="terminateApplicationForm.get('terminationReason')?.touched && terminateApplicationForm?.get('terminationReason')?.errors?.['required']" style="color:red">
          Please enter termination reason
        </div><br>
        <label for="comments">Comments:</label><br>
        <mat-form-field class="full-width">
          <textarea id="comments" formControlName="comments" matInput rows="3" maxlength="500"></textarea>
        </mat-form-field><br>
        <span id="commentsCounter" class="text-right">{{ terminateApplicationForm.get('comments')?.value.length }}/{{ MAX_COMMENTS_LENGTH }} characters remaining</span><br>
      </fieldset>
    </form>
  </ng-container>
  <ng-container *ngIf="data?.param === 'viewTerminatedReason'">
    <table>
      <tr>
        <th scope="row">Termination Date:</th>
        <td>{{ data?.content[0]['Termination Date'] }}</td>
      </tr>
      <tr>
        <th scope="row">Reason:</th>
        <td>{{ data?.content[0]['Reason'] }}</td>
      </tr>
      <tr>
        <th scope="row">Comments:</th>
        <td>{{ data?.content[0]['Comments'] }}</td>
      </tr>
      <tr>
        <th scope="row">Terminated By:</th>
        <td>{{ data?.content[0]['Terminated By'] }}</td>
      </tr>
    </table>
  </ng-container>
</mat-dialog-content>
<mat-divider></mat-divider>
<mat-dialog-actions align="end">
  <ng-container *ngIf="data?.actions.length === 2">
    <button
      mat-button
      mat-dialog-close
      cdkFocusInitial
      class="btn btn-primary-outline modal-btn-1"
      [disabled]="terminateApplicationForm.invalid"
      (click)="onSubmit()"
      >
      {{ data.actions[0] }}
    </button>
    <button
      mat-button
      mat-dialog-close
      class="btn modal-btn"
      (click)="cancel()"
      >
      {{ data.actions[1] }}
    </button>
  </ng-container>
  <ng-container *ngIf="data?.actions.length === 1">
    <button
      mat-button
      mat-dialog-close
      class="btn modal-btn"
      (click)="cancel()"
      >
      {{ data.actions[0] }}
    </button>
  </ng-container>
</mat-dialog-actions>